import type { TableSemanticSchema } from './types';

export const StakeholderSchema: TableSemanticSchema = {
  id: 'stakeholder',
  name: 'Stakeholder Map',
  description:
    'Power vs. interest 2×2 with engagement strategy. The engagement strategy derives from the quadrant (manage closely / keep satisfied / keep informed / monitor).',
  cells: [
    { id: 'manage_closely', label: 'High Power, High Interest — Manage Closely', row: 0, col: 0, accent: '#dc2626' },
    { id: 'keep_satisfied', label: 'High Power, Low Interest — Keep Satisfied', row: 0, col: 1, accent: '#f59e0b' },
    { id: 'keep_informed', label: 'Low Power, High Interest — Keep Informed', row: 1, col: 0, accent: '#2563eb' },
    { id: 'monitor', label: 'Low Power, Low Interest — Monitor', row: 1, col: 1, accent: '#64748b' },
  ],
  itemFields: [
    { key: 'power', label: 'Power', kind: 'enum', required: true,
      options: [
        { value: 'high', label: 'High' },
        { value: 'low', label: 'Low' },
      ] },
    { key: 'interest', label: 'Interest', kind: 'enum', required: true,
      options: [
        { value: 'high', label: 'High' },
        { value: 'low', label: 'Low' },
      ] },
    { key: 'engagementStrategy', label: 'Engagement Strategy', kind: 'string' },
    { key: 'contactCadence', label: 'Contact Cadence', kind: 'enum',
      options: [
        { value: 'weekly', label: 'Weekly' },
        { value: 'monthly', label: 'Monthly' },
        { value: 'quarterly', label: 'Quarterly' },
        { value: 'as_needed', label: 'As needed' },
      ] },
  ],
  renderingHints: { layout: 'quadrant' },
};
